module.exports = __webpack_public_path__ + "img/a4c5cf35736eb5a6e8cd974b9a9a72d65355451c.a2d7cc49.png";